import { Component, Input, inject, output, input } from '@angular/core';

import { IAgentCard } from '../../../models/agent.models';
import { FiltersConfig } from '@dataclouder/ngx-core';
import { AgentCardsAbstractService, CONVERSATION_AI_TOKEN } from '../../../models/conversation-ai.class';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'dc-chat-header',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss'],
})
export class ChatHeaderComponent {
  private agentCardService = inject<AgentCardsAbstractService>(CONVERSATION_AI_TOKEN);

  readonly isAdmin = input<boolean>(false);
  @Input() alternativeConversation: IAgentCard[] = [];
  @Input() agentCard!: IAgentCard;

  readonly restartConversationEvent = output<IAgentCard | null>();
  readonly showInfoEvent = output<void>();
  readonly settingsClickEvent = output<void>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  restartConversation(conversation: IAgentCard | null = null): void {
    this.restartConversationEvent.emit(conversation);
  }

  showInfo(): void {
    this.showInfoEvent.emit();
  }

  settingsClick(): void {
    this.settingsClickEvent.emit();
  }
}
